import axios from 'axios';

import { toastr } from 'react-redux-toastr';
// import fileSaver from 'file-saver';
import FileDownload from "js-file-download";
import { getToken } from '../oidc/AuthService';
import { getCallWithReducer, postCallWithReducer } from "./commonAction";

export function uploadBulk(fileCriteria,fileData,nmscCode,lang,userName,url) {


  return function (dispatch) {
    //   dispatch(setBlockingState(true));
    axios
      .post("/bulkOperation/"+url+"/"+nmscCode+"/"+lang+"/"+userName, fileData, {
        headers:
        {
          "Authorization": `Bearer ` + getToken(),
          'Content-type': 'multipart/form-data',
          'Accept': 'application/json',
          'Pragma': 'no-cache',
          'X-Frame-Options':'DENY'
        }
      })
      .then(function (response) {
        // toastr.success(I18n.t('toastr.uploadSuccess'));
        // toastr.success("Success", response.data);
        toastr.success(response.data);

        dispatch({
          type: "BULK_UPLOAD_DATA",
          payload: {isUploaded:true}
        })

        // dispatch(getBulkUploadList(fileCriteria));

      })
      .catch(function (err) {
        dispatch(getBulkUploadList(fileCriteria));
        if (err && err.status && (err.status === 429)) {
        } else {
          console.error(err);
        }
      });
  };
}


// export function getBulkUploadList(fileCriteria) {
//   return function (dispatch) {
//     // dispatch(setBlockingState(true));
//     axios.post(
//       '/bulkOperation/list', fileCriteria, {
//       headers:
//       {
//         'Content-type': 'application/json',
//         'Accept': 'application/json',
//         'Pragma': 'no-cache'
//       }

//     }).then(function (response) {

//       // dispatch(setBlockingState(false));
//       dispatch({
//         type: "UPLOAD_ACTIVITY_FILE_LIST",
//         payload: response.data
//       })
//     })
//       .catch(function (err) {

//         // dispatch(setBlockingState(false));

//       });
//   }
// }

export function getBulkUploadList(fileCriteria) {
  return function (dispatch) {
  dispatch(postCallWithReducer("/bulkOperation/list", fileCriteria,"UPLOAD_ACTIVITY_FILE_LIST"))
  };
}

export function downloadFile(id, fileName, uploadFileReqDTO) {
  return function (dispatch) {

    axios.post(
      "/bulkOperation/download/" + id, uploadFileReqDTO, {
      headers:
      {
        "Authorization": `Bearer ` + getToken(),
        'Content-type': 'application/json',
        'Pragma': 'no-cache',
        'X-Frame-Options':'DENY'
      },
    })
      .then((response) => {
        dispatch(downloadS3File(response));
      })

      .catch(function (err) {
        if (err && err.status && (err.status === 429)) {
        } else {
          toastr.error("" + err);
        }
      });
  }
}

export function downloadS3File(obj) {
  return function (dispatch) {
    //dispatch(setBlockingState(true));
    var preSignedURL = obj.data.desc;
    axios({
      method: 'get',
      contentType: "application/octet-stream",
      url: preSignedURL,
      responseType: 'arraybuffer',
      headers: { 'Pragma': 'no-cache', 'X-Frame-Options':'DENY' }
    }).then(function (response) {
      FileDownload(response.data, obj.data.body.replace(/%20/g, " "));
      //dispatch(setBlockingState(false));
    }).catch(function (err) {
      if (err && err.status && (err.status === 429)) {
      } else {
        toastr.error("" + err);
      }
    })
  };
}

export function downloadTemplate(downloadDto) {
  return function (dispatch) {
    //   dispatch(setBlockingState(true));
    axios
      .post("/bulkOperation/downloadBrit" , downloadDto, {
        headers:
        {
          'Authorization': 'Bearer ' + getToken(),
          'Content-type': 'application/json',
          'Accept': 'application/json',
          'Pragma': 'no-cache',
          'X-Frame-Options':'DENY'
        }
      })
      .then(function (response) {
        // toastr.success(I18n.t('toastr.uploadSuccess'));
        // toastr.success("Success", response.data);
        toastr.success(response.data);

        dispatch({
          type: "BULK_DOWNLOAD_DATA",
          payload: {isUploaded:true}
        })

         //dispatch(getBulkDownloadList(downloadDto));

      })
      .catch(function (err) {
        if (err && err.status && (err.status === 429)) {
        } else {
          console.log(err);
        }
      });
  };
}

export function downloadQuestionnaireTemplate(downloadDto) {
  return function (dispatch) {
    axios
      .post("/bulkOperation/downloadQuestionnaire" , downloadDto, {
        headers:
        {
          'Authorization': 'Bearer ' + getToken(),
          'Content-type': 'application/json',
          'Accept': 'application/json',
          'Pragma': 'no-cache',
          'X-Frame-Options':'DENY'
        }
      })
      .then(function (response) {
        // toastr.success(I18n.t('toastr.uploadSuccess'));
        // toastr.success("Success", response.data);
        toastr.success(response.data);

        dispatch({
          type: "QUESTIONNAIRE_DOWNLOAD_DATA",
          payload: {isUploaded:true}
        })

         //dispatch(getBulkDownloadList(downloadDto));

      })
      .catch(function (err) {
        if (err && err.status && (err.status === 429)) {
        } else {
          console.log(err);
        }
      });
  };
}

export function getBulkDownloadList( downloadDto) {
  return function (dispatch) {
    // dispatch(setBlockingState(true));
    axios.post(
      '/bulkOperation/download/list', downloadDto, {
      headers:
      {
        'Content-type': 'application/json',
        'Accept': 'application/json',
        'Pragma': 'no-cache',
        'Authorization': 'Bearer ' + getToken(),
        'X-Frame-Options':'DENY'
      }

    }).then(function (response) {
      dispatch({
        type: "DOWNLOAD_ACTIVITY_FILE_LIST",
        payload: response.data
      })
    })
      .catch(function (err) {
        if (err && err.status && (err.status === 429)) {
        } else {
          console.log(err);
        }
      });
  }
}


export function downloadTemplateFile(id, fileName, downloadFileDTO) {
  return function (dispatch) {

    axios.post(
      "/bulkOperation/downloadTemplate/" + id, downloadFileDTO, {
      headers:
      {
        'Authorization': 'Bearer ' + getToken(),
        'Content-type': 'application/json',
        'Pragma': 'no-cache',
        'X-Frame-Options':'DENY'
      },
    })
      .then((response) => {
        dispatch(downloadS3File(response));
      })
      .catch(function (err) {
        if (err && err.status && (err.status === 429)) {
        } else {
          console.log(err);
        }
      });
  }
}

export function uploadMonthlyKpi(fileCriteria, fileData, nmscCode, lang, userName) {
  return function (dispatch) {
    axios
      .post("/bulkOperation/uploadMonthlyKpi/" + nmscCode +"/"+ lang +"/"+ userName, fileData, {
        headers:
        {
          'Authorization': 'Bearer ' + getToken(),
          'Content-type': 'multipart/form-data',
          'Accept': 'application/json',
          'Pragma': 'no-cache',
          'X-Frame-Options':'DENY'
        }
      })
      .then(function (response) {
        toastr.success(response.data);

        dispatch({
          type: "KPI_UPLOAD_DATA",
          payload: {isUploaded:true}
        })
      })
      .catch(function (err) {
        dispatch(getMonthlyKpiUploadList(fileCriteria));
        if (err && err.status && (err.status === 429)) {
        } else {
          console.log(err);
        }
      });
  };
}

// export function uploadValueChainQuestionnaire(fileCriteria, fileData, nmscCode, lang, userName) {
//   return function (dispatch) {
//     axios
//       .post("/bulkOperation/uploadValueChainQuestionnaire/" + nmscCode +"/"+ lang +"/"+ userName, fileData, {
//         headers:
//         {
//           'Content-type': 'multipart/form-data',
//           'Accept': 'application/json',
//           'Pragma': 'no-cache'
//         }
//       })
//       .then(function (response) {
//         toastr.success(response.data);

//         dispatch({
//           type: "KPI_UPLOAD_DATA",
//           payload: {isUploaded:true}
//         })
//       })
//       .catch(function (err) {
//         console.log(err);
//         dispatch(getMonthlyKpiUploadList(fileCriteria));
//       });
//   };
// }

export function uploadUsedCars(fileCriteria, fileData, nmscCode, lang, userName, activeProgramID, ceaDefaultYears, activeProgramUc) {
  return function (dispatch) {
    axios
      .post("/bulkOperation/uploadUsedCars/" + nmscCode +"/"+ lang +"/"+ userName +"/"+ activeProgramID +"/"+ ceaDefaultYears+"/"+activeProgramUc, fileData, {
        headers:
        {
          'Authorization': 'Bearer ' + getToken(),
          'Content-type': 'multipart/form-data',
          'Accept': 'application/json',
          'Pragma': 'no-cache',
          'X-Frame-Options':'DENY'
        }
      })
      .then(function (response) {
        toastr.success(response.data);

        dispatch({
          type: "KPI_UPLOAD_DATA",
          payload: {isUploaded:true}
        })
      })
      .catch(function (err) {
        dispatch(getMonthlyKpiUploadList(fileCriteria));
        if (err && err.status && (err.status === 429)) {
        } else {
          console.log(err);
        }
      });
  };
}

export function uploadNetworks(fileCriteria, fileData, nmscCode, lang, userName, activeProgramID, ceaDefaultYears, activeProgramNet) {
  return function (dispatch) {
    axios
      .post("/bulkOperation/uploadNetworks/" + nmscCode +"/"+ lang +"/"+ userName +"/"+ activeProgramID +"/"+ ceaDefaultYears+"/"+activeProgramNet, fileData, {
        headers:
        {
          'Authorization': 'Bearer ' + getToken(),
          'Content-type': 'multipart/form-data',
          'Accept': 'application/json',
          'Pragma': 'no-cache',
          'X-Frame-Options':'DENY'
        }
      })
      .then(function (response) {
        toastr.success(response.data);

        dispatch({
          type: "KPI_UPLOAD_DATA",
          payload: {isUploaded:true}
        })
      })
      .catch(function (err) {
        dispatch(getMonthlyKpiUploadList(fileCriteria));
        if (err && err.status && (err.status === 429)) {
        } else {
          console.log(err);
        }
      });
  };
}

export function uploadLexusNetworks(fileCriteria, fileData, nmscCode, lang, userName, activeProgramID, ceaDefaultYears, activeProgramLN) {
  return function (dispatch) {
    axios
      .post("/bulkOperation/uploadLexusNetworks/" + nmscCode +"/"+ lang +"/"+ userName +"/"+ activeProgramID +"/"+ ceaDefaultYears+"/"+activeProgramLN, fileData, {
        headers:
        {
          'Authorization': 'Bearer ' + getToken(),
          'Content-type': 'multipart/form-data',
          'Accept': 'application/json',
          'Pragma': 'no-cache',
          'X-Frame-Options':'DENY'
        }
      })
      .then(function (response) {
        toastr.success(response.data);

        dispatch({
          type: "KPI_UPLOAD_DATA",
          payload: {isUploaded:true}
        })
      })
      .catch(function (err) {
        dispatch(getMonthlyKpiUploadList(fileCriteria));
        if (err && err.status && (err.status === 429)) {
        } else {
          console.log(err);
        }
      });
  };
}

export function getMonthlyKpiUploadList(fileCriteria) {
    return function (dispatch) {
    dispatch(postCallWithReducer("/activity/monthlyKpiList",fileCriteria,"KPI_UPLOAD_FILE_LIST"))
    };
}
export function downloadData(fileCriteria) {

  return function (dispatch) {
    dispatch({
      type: "DATA_UPLOAD_FILE_LIST",
      payload: fileCriteria
    });

  };
}

export function uploadData(fileCriteria) {

  return function (dispatch) {
    dispatch({
      type: "UPLOAD_LIST",
      payload: fileCriteria
    });

  };
}

export function getkpiUploadList(fileCriteria) {

  return function (dispatch) {
    dispatch({
      type: "UPLOAD_KPI_LIST",
      payload: fileCriteria
    });

  };
}

export function getQuestionnaireUploadList(fileCriteria) {

  return function (dispatch) {
    dispatch({
      type: "UPLOAD_QUESTIONNAIRE_LIST",
      payload: fileCriteria
    });

  };
}


export function getMonthlyKpiUploadedList(fileCriteria) {
  return function (dispatch) {
  dispatch(postCallWithReducer("/bulkOperation/monthlyKpiList",fileCriteria,"KPI_UPLOADED_FILE_LIST"))
  };
}

/** used cars accessory performance download templete */
export function downloadUsedCarsTemplate(role, nmsc) {
  return function (dispatch) {
    const url='/uc_accessory_performance/generate_template';
    const paramsData = new URLSearchParams(`?userRole=${encodeURIComponent(role)}&nmscCode=+${encodeURIComponent(nmsc)}`);

    axios.get(url, {
        params: paramsData,
        headers: {
        'Authorization': 'Bearer ' + getToken(),
        "Content-type": "application/json",
        'Accept': "application/json",
            unblockUI: true
        },
        responseType: 'blob',
    })
        .then(response => {
          const contentDisposition = response.headers['content-disposition'];
          let fileName = 'UC_Download_Template.xlsx'; // Default file name
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename="?(.+)"?/);
            if (fileNameMatch && fileNameMatch[1]) {
              fileName = fileNameMatch[1];
            }
          }
  
          // Download the file with the correct name
          FileDownload(response.data, decodeURI(fileName.replace(/\+/g, ' ')));
        })
        .catch(function (error) {
            if (error && error.status && (error.status === 429)) {
            } else {
                toastr.error(error.message);
            }
        });
}
}

export function getUsedCarsUploadList(fileCriteria) {

  return function (dispatch) {
    dispatch({
      type: "UPLOAD_USED_CARS_LIST",
      payload: fileCriteria
    });

  };
}

export function getBulkUploadUsedCarsList(fileCriteria) {
  return function (dispatch) {
  dispatch(postCallWithReducer("/bulkOperation/list", fileCriteria,"UPLOAD_ACTIVITY_USED_CARS_FILE_LIST"))
  };
}

export function uploadBulkUsedCars(fileCriteria,fileData,nmscCode,role,userName,url) {
  return function (dispatch) {
    axios
      .post("/bulkOperation/"+url+"/"+nmscCode+"/"+role+"/"+userName, fileData, {
        headers:
        {
          "Authorization": `Bearer ` + getToken(),
          'Content-type': 'multipart/form-data',
          'Accept': 'application/json',
          'Pragma': 'no-cache'
        }
      })
      .then(function (response) {
        toastr.success(response.data);
        dispatch({
          type: "BULK_UPLOAD_DATA",
          payload: {isUploaded:true}
        })

      })
      .catch(function (err) {
        console.log(err);
        dispatch(getBulkUploadList(fileCriteria));
      });
  };
}